export const GET_TIME_SLOTS = "GET_TIME_SLOTS";
export const TIME_SLOT_IN_PROCESS = "TIME_SLOT_IN_PROCESS";
export const RECEIVE_TIME_SLOTS = "RECEIVE_TIME_SLOTS";
